export const sidebarPagesListCollapsed = () => {
  return { type: 'ui/sidebar/PAGES_LIST_COLLAPSED' };
};

export const sidebarPagesListExpanded = () => {
  return { type: 'ui/sidebar/PAGES_LIST_EXPANDED' };
};

export const sidebarBlogsListCollapsed = () => {
  return { type: 'ui/sidebar/BLOGS_LIST_COLLAPSED' };
};

export const sidebarBlogsListExpanded = () => {
  return { type: 'ui/sidebar/BLOGS_LIST_EXPANDED' };
};

export const sidebarAssetsListCollapsed = () => {
  return { type: 'ui/sidebar/ASSETS_LIST_COLLAPSED' };
};

export const sidebarAssetsListExpanded = () => {
  return { type: 'ui/sidebar/ASSETS_LIST_EXPANDED' };
};



// WEBPACK FOOTER //
// ./client/RLX/State/Ui/Sidebar/SidebarCreators.js